<template>
  <div class="row customers">
    <div class="col-lg-12 col-md-12 col-xs-12 noprint">
      <div class="action-buttons">
        <div class="left-group" style="display: flex; flex-wrap: nowrap; gap: 8px; align-items: flex-end; flex: 0 1 auto; margin-top: 20px;">
          <div class="form-group" style="max-width: 150px;">
            <label>ID</label>
            <el-input
              v-model="searchId"
              :placeholder="'Introdu ID-ul'"
            ></el-input>
          </div>

          <div class="form-group" style="max-width: 250px;">
            <label>{{ $t('settingsPages.searchNameEmail') }}</label>
            <el-input
              v-model="search"
              :placeholder="$t('general.search')"
            ></el-input>
          </div>

          <div class="form-group" style="display: flex; flex-direction: column;">
            <label>{{ $t('settingsPages.dateTime') }}</label>
            <el-date-picker
              type="datetimerange"
              v-model="searchDate"
              format="yyyy-MM-dd HH:mm"
              value-format="yyyy-MM-dd HH:mm:ss"
              class="w-100"
              :picker-options="pickerOptions"
              :name="['date_from', 'date_to']"
              :disabled="loading"
            ></el-date-picker>
          </div>

          <div class="form-group" style="
              display: flex;
              flex-direction: column;
          ">
            <label>{{$t('addOrder.choosePay')}}</label>
            <el-select
              v-model="selectedPaymentMethod"
              multiple
              collapse-tags
              :placeholder="$t('settingsPages.filters')"
              class="filter-select"
            >
              <el-option
                v-for="(val, key) in paymentMethods"
                :key="key"
                :label="val.name"
                :value="val.name">
              </el-option>
            </el-select>
          </div>

          <!-- Select pentru filtre -->
          <div class="form-group" style="
              display: flex;
              flex-direction: column;
          ">
            <label>{{ $t('settingsPages.ordersFilter') }}</label>
            <el-select
              v-model="filters"
              multiple
              collapse-tags
              :placeholder="$t('settingsPages.filters')"
              class="filter-select"
            >
              <el-option
                v-for="(loc, key) in filterOptions"
                :key="key"
                :label="loc"
                :value="key">
              </el-option>
            </el-select>
          </div>

          <div class="search-button-reports">
            <button
              :title="$t('reports.search')"
              class="btn add mar-rt-10"
              @click="handleSearch"
            >
              <i class="ti-search"></i>
              <span>{{ $t('general.search') }}</span>
            </button>
          </div>
        </div>
      </div>

      <div class="card mar-to-15">
        <div class="card-content">
          <div :class="(loading ? 'show-loader' : 'hide-loader')">
            <div class="el-loading-spinner">
              <svg viewBox="25 25 50 50" class="circular">
                <circle cx="50" cy="50" r="20" fill="none" class="path"></circle>
              </svg>
            </div>
          </div>

          <div class="data-table customers-table">
            <el-table
              :data="tableData"
              :empty-text="$t('gestiune.noData')"
              @row-click="goToRecord"
              :row-class-name="rowClass"
            >
              <el-table-column :label="$t('customers.id')" prop="id" width="80">
                <template slot-scope="scope">
                  #{{ scope.row.id }}
                </template>
              </el-table-column>

              <el-table-column :label="$t('customers.email')" prop="email">
                <template slot-scope="scope">
                  {{ scope.row.email }}
                </template>
              </el-table-column>

              <el-table-column :label="$t('customers.phone')" prop="phone">
                <template slot-scope="scope">
                  {{ scope.row.phone }}
                </template>
              </el-table-column>

              <el-table-column :label="$t('customers.fidelities')" prop="label_level">
                <template slot-scope="scope">
                  {{ scope.row.label_level ? scope.row.label_level.label_name : scope.row.label_level }}
                </template>
              </el-table-column>

              <el-table-column :label="$t('orders.counterPerCustomer')" prop="counter_orders_per_customer" width="140">
                <template slot-scope="scope">
                  {{ scope.row.counter_orders_per_customer }}
                </template>
              </el-table-column>

              <el-table-column :label="$t('customers.totalSales')" prop="sales" width="140" align="right">
                <template slot-scope="scope">
                  {{ scope.row.sales && scope.row.sales > 0 ? formatMoneyAmount(scope.row.sales) : '-' }}
                </template>
              </el-table-column>

              <el-table-column :label="$t('marketingOffers.actions')" width="100" align="center">
                <template slot-scope="scope">
                  <el-dropdown trigger="click" placement="bottom-end" @click.native.stop>
                    <span class="arrow-box">
                      &#9662;
                    </span>
                    <el-dropdown-menu slot="dropdown">
                      <el-dropdown-item @click.native.stop="goToRecord(scope.row, $event, {})">
                        {{ $t('gestiune.view') }}
                      </el-dropdown-item>
                    </el-dropdown-menu>
                  </el-dropdown>
                </template>
              </el-table-column>
            </el-table>

            <el-pagination
              :total="paginationDef.totalRecords"
              :page-size="paginationDef.perPage"
              :pager-count="pagerCount"
              :current-page="paginationDef.page"
              layout="prev, pager, next, total"
              @current-change="handlePageChange($event)"
              @prev-click="handlePageChange($event)"
              @next-click="handlePageChange($event)"
              style="margin-top: 15px; text-align: center;"
            ></el-pagination>
          </div>
        </div>
      </div>
    </div>
    <customer-view
      v-if="showForm()"
      ref="customerForm"
      :route="route">
    </customer-view>
  </div>
</template>

<script>
  import Vue from 'vue'
  import {Input, Table, TableColumn, Select, Option, Pagination, Row, Dropdown, DropdownMenu, DropdownItem, Checkbox, CheckboxGroup, Button} from 'element-ui'
  import DataTables from 'vue-data-tables'
  import PSwitch from 'src/components/UIComponents/Switch.vue'
  import PPagination from 'src/components/UIComponents/Pagination.vue'
  import swal from 'sweetalert2'
  import 'sweetalert2/dist/sweetalert2.css'
  import CustomerView from './CustomerView.vue'

  Vue.use(Input)
  Vue.use(Table)
  Vue.use(TableColumn)
  Vue.use(Select)
  Vue.use(Option)
  Vue.use(Pagination)
  Vue.use(DataTables)
  Vue.use(Row)
  Vue.use(Dropdown)
  Vue.use(DropdownMenu)
  Vue.use(DropdownItem)
  Vue.use(Checkbox)
  Vue.use(CheckboxGroup)
  Vue.use(Button)

  export default{
    components: {
      PPagination,
      PSwitch,
      CustomerView
    },
    computed: {
    },
    data () {
      return {
        loading: true,
        paginationDef: {
          page: null,
          totalPages: null,
          totalRecords: null,
          show: true
        },
        searchId: null,
        searchDate: null,
        selectedPaymentMethod: null,
        route: {},
        pagerCount: 5,
        paymentMethods: [],
        filterOptions: this.$t('customers.filters'),
        filters: [],
        searchQuery: '',
        propsToSearch: ['name', 'email', 'age'],
        tableColumns: [],
        tableData: [],
        windowHeight: 0,
        tableTopHeight: 104,
        tableBottomHeight: 68,
        pageTopHeight: 0,
        search: '',
        pickerOptions: {
          shortcuts: [
            {
              text: 'Astăzi',
              onClick (picker) {
                const start = new Date()
                start.setHours(0, 0, 0, 0)
                const end = new Date()
                end.setHours(23, 59, 59, 999)
                picker.$emit('pick', [start, end])
              }
            },
            {
              text: 'Ieri',
              onClick (picker) {
                const start = new Date()
                start.setDate(start.getDate() - 1)
                start.setHours(0, 0, 0, 0)
                const end = new Date()
                end.setDate(end.getDate() - 1)
                end.setHours(23, 59, 59, 999)
                picker.$emit('pick', [start, end])
              }
            },
            {
              text: 'Ultimele 7 zile',
              onClick (picker) {
                const end = new Date()
                end.setHours(23, 59, 59, 999)
                const start = new Date()
                start.setDate(end.getDate() - 6)
                start.setHours(0, 0, 0, 0)
                picker.$emit('pick', [start, end])
              }
            },
            {
              text: 'Ultimele 30 de zile',
              onClick (picker) {
                const end = new Date()
                end.setHours(23, 59, 59, 999)
                const start = new Date()
                start.setDate(end.getDate() - 29)
                start.setHours(0, 0, 0, 0)
                picker.$emit('pick', [start, end])
              }
            },
            {
              text: 'Luna curentă',
              onClick (picker) {
                const start = new Date()
                start.setDate(1)
                start.setHours(0, 0, 0, 0)
                const end = new Date()
                end.setHours(23, 59, 59, 999)
                picker.$emit('pick', [start, end])
              }
            },
            {
              text: 'Luna trecută',
              onClick (picker) {
                const date = new Date()
                const start = new Date(date.getFullYear(), date.getMonth() - 1, 1)
                start.setHours(0, 0, 0, 0)
                const end = new Date(date.getFullYear(), date.getMonth(), 0)
                end.setHours(23, 59, 59, 999)
                picker.$emit('pick', [start, end])
              }
            },
            {
              text: 'Anul curent',
              onClick (picker) {
                const start = new Date(new Date().getFullYear(), 0, 1)
                start.setHours(0, 0, 0, 0)
                const end = new Date()
                end.setHours(23, 59, 59, 999)
                picker.$emit('pick', [start, end])
              }
            },
            {
              text: 'Anul trecut',
              onClick (picker) {
                const year = new Date().getFullYear() - 1
                const start = new Date(year, 0, 1)
                start.setHours(0, 0, 0, 0)
                const end = new Date(year, 11, 31)
                end.setHours(23, 59, 59, 999)
                picker.$emit('pick', [start, end])
              }
            }
          ],
          onPick ({ maxDate, minDate }) {
            if (minDate && !maxDate) {
              minDate.setHours(0, 0, 0, 0)
            }
            if (maxDate) {
              maxDate.setHours(23, 59, 59, 999)
            }
          }
        }
      }
    },
    created () {
      this.initializePage()
      this.getPaymentMethods()

      this.$bus.$on('refresh', this.handleRefresh)
    },
    beforeDestroy () {
      this.$bus.$off('refresh', this.handleRefresh)
    },
    methods: {
      handleRefresh () {
        this.handleSearch()
      },
      buildRequestData (page = null) {
        var currentPage = page

        if (!currentPage) {
          if (this.paginationDef && this.paginationDef.page) {
            currentPage = this.paginationDef.page
          } else {
            currentPage = 1
          }
        }

        const data = {
          token: this.$session.get('token'),
          company_id: this.$session.get('selectedCompany'),
          page: currentPage,
          perPage: this.paginationDef.perPage,
          filters: this.filters
        }

        if (this.search && this.search.length > 3) {
          data.search = this.search
        }

        if (this.searchId && this.searchId.length > 0) {
          data.id = this.searchId
        }

        if (this.searchDate && this.searchDate.length === 2) {
          data.date_from = this.searchDate[0]
          data.date_to = this.searchDate[1]
        }

        if (this.selectedPaymentMethod && this.selectedPaymentMethod.length > 0) {
          data.payment_type = this.selectedPaymentMethod
        }

        return data
      },
      initializePage () {
        const data = this.buildRequestData()

        this.getCustomers(data)
      },
      handlePageChange (newPage) {
        this.paginationDef.page = newPage
        this.requestPage = newPage
        const data = this.buildRequestData()
        this.getCustomers(data)
      },

      handleSearch () {
        this.requestPage = 1
        const data = this.buildRequestData()
        this.getCustomers(data)
      },
      getCustomers (data) {
        // var self = this
        this.loading = true
        this.apiRequest('customer-lightview', 'GET', data, (response) => {
          if (response.status === true) {
            this.tableData = response.data.data
            this.paginationDef.page = response.data.pagination.page
            this.paginationDef.perPage = response.data.pagination.perPage
            this.paginationDef.totalPages = response.data.pagination.totalPages
            this.paginationDef.totalRecords = response.data.pagination.totalRecords
            // this.$router.push('/customers')
          }
          this.$nextTick(function () {
            this.loading = false
          })
        })
      },
      getPaymentMethods () {
        let sessionData = this.$session.get('selectedCompanyData')

        if (!sessionData['payment_methods']) {
          var data = {
            token: this.$session.get('token'),
            company_id: this.$session.get('selectedCompany')
          }

          this.apiRequest('/orders/get-payment-methods', 'GET', data, (response) => {
            if (response.status && response.data.length) {
              let result = response.data.map(item => {
                return {id: item || 'unpaid', name: this.$t('paymentTypes.' + item)}
              })
              sessionData['payment_methods'] = response.data
              this.$session.set('selectedCompanyData', sessionData)

              Vue.set(this, 'paymentMethods', result)
            }
          })
        } else {
          let result = sessionData['payment_methods'].map(item => {
            return {id: item || 'unpaid', name: this.$t('paymentTypes.' + item)}
          })
          Vue.set(this, 'paymentMethods', result)
        }
      },
      goToRecord (row, event, column) {
        this.$router.push('/customers/view/' + row.id)
        // this.globalGoToRecord(row, event, column, '/customers/view/')
        // if (this.$refs.customerForm) {
        //   this.$refs.customerForm.getData()
        // }
      },
      rowClass (row, index) {
        if (this.$route.params.id && (parseInt(row.row.id) === parseInt(this.$route.params.id))) {
          return 'current'
        } else {
          return ''
        }
      },
      showForm () {
        if (this.$route.path.indexOf('view') !== -1) {
          return true
        } else {
          return false
        }
      },
      handleActive (index, row) {
        let actionText = row.active ? 'activate' : 'deactivate'
        swal({
          text: `Are you sure you want to ${actionText} ${row.name}?`,
          type: 'question',
          showCancelButton: true,
          confirmButtonText: 'Yes'
        }).then((result) => {
          if (result) {
            this.apiRequest('/hello', 'GET', [], function (response) {
              if (response.status) {
                swal(
                  'Success!',
                  '',
                  'success'
                )
              } else {
                swal(
                  '',
                  'Something went wrong, please try again later...',
                  'error'
                )
                row.active = !row.active
              }
            })
          }
        }).catch(() => {
          swal(
            '',
            'Something went wrong, please try again later...',
            'error'
          )
          row.active = !row.active
        })
      }
    }
  }
</script>

<style scoped>
.customers .fixed .dropdown-sm {
  width: 22%;
}
.left-buttons {
  display: flex;
  align-items: center;
  gap: 5px;
  margin-top: 20px;
}
.form-group {
  margin-bottom: 0px !important;
}
.arrow-box {
  display: inline-block;
  font-size: 18px;
  padding: 4px 6px;
  border: 1px solid #674BD2 !important;
  border-radius: 4px;
  cursor: pointer;
  text-align: center;
  user-select: none;
  transition: background-color 0.2s, border-color 0.2s, color 0.2s;
  color: #674BD2;
}
.el-tag.el-tag--info {
  color: #fff !important;
}
.arrow-box:hover {
  background-color: #674BD2 !important;
  border-color: #674BD2 !important;
  color: #fff !important;
}

.filter-select {
  min-width: 150px;
}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Customers/Customers.vue